import { LINK } from '@constants';
import type { ButtonProps } from '@viewup/ui';
import { Button, Icon, Login2 } from '@viewup/ui';
import { useConfirmGuideline } from '../../api/useConfirmGuideline';

export type DownloadGuideButtonProps = ButtonProps & {
  accountUuid: string;
  campaignUuid: string;
  postViewingRecordUuid: string;
  guidelineUrl: string;
  isUpdated: boolean;
};
export const DownloadGuidelineButton = (props: DownloadGuideButtonProps) => {
  const { campaignUuid, accountUuid, isUpdated, postViewingRecordUuid, ...buttonProps } = props;
  const { mutate: confirmGuideline } = useConfirmGuideline();

  const handleClick = () => {
    if (isUpdated) {
      confirmGuideline({
        postViewingRecordUuid,
      });
    }

    window.open(
      `${LINK.VIEWING_POST_GUIDE}?campaignUuid=${campaignUuid}&accountUuid=${accountUuid}`,
      '_blank',
    );
  };

  return (
    <Button {...buttonProps} leftContent={<Icon source={Login2} />} onClick={handleClick}>
      가이드라인
    </Button>
  );
};
